import React from 'react';
import { DOOR_OPTIONS } from '../data/site';
import { WhatsAppButton } from './WhatsAppButton';
export function DoorsSection() {
  return <section className="bg-navy-900 py-10 text-white sm:py-16" data-id="element-29" data-mp="k1noxr4ggh4z">
      <div className="mx-auto max-w-content px-4 sm:px-6" data-id="element-30" data-mp="f3cjrtp3uut3">
        <h2 className="font-display text-[1.75rem] font-bold leading-tight sm:text-4xl" data-id="element-31" data-mp="f1rkjqruinow">
          Elige la puerta correcta para tu obra
        </h2>
        <p className="mt-2 text-sm text-steel-200 sm:text-base" data-id="element-32" data-mp="17rqhe8ca7p44">Tres caminos, una misma salida: tu material en obra.</p>

        <div className="mt-6 grid gap-3 md:grid-cols-3 md:gap-5" data-id="element-33" data-mp="12u88uj26fbwn">
          {DOOR_OPTIONS.map((door, index) => <div key={door.id} className="flex flex-col rounded-xl border border-white/10 bg-navy-800 p-4 transition-colors duration-150 ease-out hover:border-accent-500/70 sm:p-6" data-id="element-34" data-mp="yu7rapjs6kld" data-mpi={index}>
              <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-accent-500" data-id="element-35" data-mp="3ejivdcri0icc">
                Puerta {index + 1}
              </span>
              <h3 className="mt-1.5 font-display text-xl font-semibold leading-tight sm:text-2xl" data-id="element-36" data-mp="2mbqowehtqgtm">{door.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-steel-200" data-id="element-37" data-mp="2r7o1qatvp51n">{door.text}</p>
              <div className="mt-auto pt-4" data-id="element-38" data-mp="2dcd9z6axl01i">
                <WhatsAppButton message={door.message} label="Cotizar por WhatsApp" location="puertas" intent={door.id} fullWidth data-id="element-39" data-mp="2i8kk7bad0xp9" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}